var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { AiDraftStatus } from '../enums/ai-draft-status.enum.js';
import { AiFailureReason } from '../enums/ai-failure-reason.enum.js';
import { DictationFailedStep } from '../enums/dictation-failed-step.enum.js';
import { DictationPhase } from '../enums/dictation-phase.enum.js';
import { DictationStatus } from '../enums/dictation-status.enum.js';
import { TranscriptStatus } from '../enums/transcript-status.enum.js';
import { AiDraftPayloadDto, ReviewHintDto } from './ai-draft-payload.dto.js';
/** The newest transcription run of the dictation. `text` is null until it is `READY`. */
export class DictationTranscriptDto {
    id;
    status;
    text;
    repetitionTrimmed;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], DictationTranscriptDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsEnum(TranscriptStatus),
    __metadata("design:type", String)
], DictationTranscriptDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], DictationTranscriptDto.prototype, "text", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], DictationTranscriptDto.prototype, "repetitionTrimmed", void 0);
/** The newest generation run of the dictation. `payload` is null until it is `READY`. */
export class DictationDraftDto {
    id;
    status;
    payload;
    reviewHints;
    schemaVersion;
    promptVersion;
    /** `AiFailureReason` of a `FAILED` draft (validation, provider_rejected, …), null otherwise. */
    failureReason;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], DictationDraftDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsEnum(AiDraftStatus),
    __metadata("design:type", String)
], DictationDraftDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => AiDraftPayloadDto),
    __metadata("design:type", Object)
], DictationDraftDto.prototype, "payload", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ReviewHintDto),
    __metadata("design:type", Object)
], DictationDraftDto.prototype, "reviewHints", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DictationDraftDto.prototype, "schemaVersion", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DictationDraftDto.prototype, "promptVersion", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsEnum(AiFailureReason),
    __metadata("design:type", Object)
], DictationDraftDto.prototype, "failureReason", void 0);
/**
 * `GET /ai-documentation/dictations/:id` (Spec § 9), author only: the state of
 * the run and, once there, the transcript and the draft the review works on.
 * `failureReason` is a code, never text (Spec § 4.3).
 */
export class DictationDetailResponseDto {
    id;
    status;
    phase;
    failedStep;
    failureReason;
    audioAvailable;
    transcript;
    latestDraft;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], DictationDetailResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsEnum(DictationStatus),
    __metadata("design:type", String)
], DictationDetailResponseDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsEnum(DictationPhase),
    __metadata("design:type", String)
], DictationDetailResponseDto.prototype, "phase", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsEnum(DictationFailedStep),
    __metadata("design:type", Object)
], DictationDetailResponseDto.prototype, "failedStep", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsEnum(AiFailureReason),
    __metadata("design:type", Object)
], DictationDetailResponseDto.prototype, "failureReason", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], DictationDetailResponseDto.prototype, "audioAvailable", void 0);
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => DictationTranscriptDto),
    __metadata("design:type", Object)
], DictationDetailResponseDto.prototype, "transcript", void 0);
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => DictationDraftDto),
    __metadata("design:type", Object)
], DictationDetailResponseDto.prototype, "latestDraft", void 0);
//# sourceMappingURL=dictation-detail-response.dto.js.map